<template>
  <div class="oa-related-picker">
    <div v-if="readOnly" class="oa-related-read"><template v-for="(row,index) in selectedRows"><span v-if="index" :key="row.id+'separator'">；</span><router-link :key="row.id" :to="'/oa/related-approval/'+row.id">{{row.number || '审批单 #'+row.id}}<template v-if="row.title"> · {{row.title}}</template></router-link></template><span v-if="!selectedRows.length">—</span></div>
    <template v-else>
      <el-select v-model="approvalType" class="oa-related-category" filterable clearable :disabled="disabled" :loading="typesLoading" placeholder="全部审批分类" aria-label="审批分类" @change="changeType">
        <el-option-group v-for="group in typeGroups" :key="group.name" :label="group.name">
          <el-option v-for="type in group.items" :key="type.id" :label="type.name" :value="type.id" />
        </el-option-group>
      </el-select>
      <el-select :key="approvalType || 'all'" :value="value" multiple filterable remote :remote-method="search" :loading="loading" :disabled="disabled" placeholder="搜索审批编号或申请主题" aria-label="关联审批单" @visible-change="open" @input="change">
        <el-option v-for="row in choiceRows" v-show="isResult(row.id)" :key="row.id" :label="row.name" :value="row.id">
          <span>{{ row.name }}</span><small v-if="row.approvalTypeName" class="oa-related-type">{{ row.approvalTypeName }}</small>
        </el-option>
      </el-select>
      <div v-if="loaded && !loading && !rows.length && !error" class="oa-related-hint">当前分类暂无匹配的可关联审批单，可更换分类或搜索词</div>
      <div v-else-if="rows.length >= 100" class="oa-related-hint">可输入完整编号或申请主题，查找更多审批单</div>
    </template>
    <el-alert v-if="error || typesError" :title="error || typesError" type="warning" :closable="false" show-icon />
    <el-button v-if="typesError && !readOnly" type="text" :disabled="typesLoading || disabled" @click="loadTypes">重新加载审批分类</el-button>
  </div>
</template>
<script>
import * as api from '@/api/crm/oaBusiness'

export default {
  name: 'OaRelatedApprovalSelect',
  props: { value: { type: Array, default: () => [] }, disabled: Boolean, readOnly: Boolean },
  data() { return { approvalType: null, types: [], rows: [], cache: {}, loading: false, hydrating: false, typesLoading: false, loaded: false, error: '', typesError: '', sequence: 0, hydrateSequence: 0, typeSequence: 0 } },
  computed: {
    typeGroups() {
      const groups = {}
      this.types.forEach(type => { const name = type.category || '其他审批'; (groups[name] || (groups[name] = [])).push(type) })
      return Object.keys(groups).map(name => ({ name, items: groups[name] }))
    },
    selectedRows() { return this.value.map(id => this.cache[String(id)] || { id, name: this.hydrating ? '正在读取已关联审批单…' : '审批单 #'+id }) },
    choiceRows() {
      const seen = new Set()
      return [...this.rows, ...this.selectedRows].filter(row => !seen.has(String(row.id)) && seen.add(String(row.id)))
    }
  },
  watch: { value: { immediate: true, handler: 'hydrate' } },
  created() { if (!this.readOnly) { this.loadTypes(); this.search('') } },
  beforeDestroy() { this.sequence++; this.hydrateSequence++; this.typeSequence++ },
  methods: {
    isResult(id) { return this.rows.some(row => String(row.id) === String(id)) },
    async loadTypes() {
      const seq = ++this.typeSequence; this.typesLoading = true; this.typesError = ''
      try { const r = await api.relatedTypes(); if (seq === this.typeSequence) this.types = r.data || [] }
      catch (e) { if (seq === this.typeSequence) this.typesError = e.message || '审批分类加载失败，请重试' }
      finally { if (seq === this.typeSequence) this.typesLoading = false }
    },
    async hydrate() {
      const seq = ++this.hydrateSequence, ids = this.value.filter(id => !this.cache[String(id)])
      this.hydrating = !!ids.length
      if (!ids.length) return
      try {
        const r = await api.related({ ids: ids.join(',') })
        if (seq !== this.hydrateSequence) return
        for (const row of r.data || []) if (this.value.some(id => String(id) === String(row.id))) this.$set(this.cache, String(row.id), row)
      } catch (e) { if (seq === this.hydrateSequence) this.error = e.message || '已关联审批单加载失败，请重试' }
      finally { if (seq === this.hydrateSequence) this.hydrating = false }
    },
    open(visible) { if (visible) return this.search('') },
    changeType() { return this.search('') },
    async search(keyword) {
      const seq = ++this.sequence; this.loading = true; this.error = ''; this.rows = []
      try {
        const r = await api.related({ keyword, approvalType: this.approvalType || null })
        if (seq !== this.sequence) return
        this.rows = r.data || []; this.loaded = true
        for (const row of this.rows) if (this.value.some(id => String(id) === String(row.id))) this.$set(this.cache, String(row.id), row)
      } catch (e) { if (seq === this.sequence) this.error = e.message || '审批单加载失败，请重试' }
      finally { if (seq === this.sequence) this.loading = false }
    },
    change(ids) {
      for (const id of ids) { const row = this.choiceRows.find(row => String(row.id) === String(id)); if (row) this.$set(this.cache, String(id), row) }
      this.$emit('input', ids)
    }
  }
}
</script>
<style scoped>
.oa-related-picker .el-select{width:100%}.oa-related-category{margin-bottom:10px}.oa-related-read{line-height:1.8;white-space:pre-wrap;overflow-wrap:anywhere}.oa-related-hint{font-size:12px;line-height:1.6;color:#8491a5;margin-top:7px}.oa-related-type{color:#8491a5;margin-left:14px}.oa-related-picker .el-alert{margin-top:10px}
</style>
